import { createFileRoute, redirect } from "@tanstack/react-router"
import * as v from "valibot"

import { getBoardsQueryOptions } from "@/api/query/boardsQueryOptions"
import { DEVICEGRAPH_TIMEFRAME } from "@/components/graphing/DeviceStatusGraph/constants"
import { routeGuard } from "@/lib/routing/beforeLoad"

const searchSchema = v.object({
  graph: v.fallback(
    v.optional(
      v.union(Object.keys(DEVICEGRAPH_TIMEFRAME).map(key => v.literal(key as keyof typeof DEVICEGRAPH_TIMEFRAME)))
    ),
    undefined
  )
})

export const Route = createFileRoute("/_authlayout/_header/devices/$id/")({
  validateSearch: searchSchema,
  beforeLoad: async ({ context }) => {
    await routeGuard(context)
  },
  loader: async ({ context: { queryClient, deviceQueryOptions }, location }) => {
    // A bare `query()`, not `staleTime: "static"`: the `$id` route validates
    // with the same key, so this dedupes onto its in-flight fetch instead of
    // resolving to a stale copy — the redirect below is decided on it. The rejection is
    // swallowed on purpose: that route owns validation, and an error escaping
    // here would surface a raw API error ahead of its `notFound()`.
    const [device] = await Promise.all([
      queryClient.query(deviceQueryOptions).catch(() => undefined),
      queryClient.query({ ...getBoardsQueryOptions(), staleTime: "static" })
    ])

    if (!device) return

    // Evaluate redirection to thing page.

    const search = location.search as v.InferOutput<typeof searchSchema>

    // Redirect to thing page if device is attached to a thing.
    if (device.thing) {
      redirect({
        to: "/things/$id",
        params: { id: device.thing.id },
        search: { tab: "device", graph: search.graph },
        throw: true
      })
    }
  }
})
